import React, { useState, useMemo } from "react";
import styles from "./SelectList.module.scss";
import { SelectItem } from "./SelectItem";
import { NestedSelectItem } from "./NestedSelectItem";
import { Spinner, Checkbox } from "@blueprintjs/core";

/*{
data = [
  {
    value: STRING,
    text: STRING,
    imageUrl: STRING <optional>
  },
  {
    value: STRING,
    text: STRING,
    imageUrl: STRING <optional>,
    children: [{ value: STRING, text: STRING, imageUrl: STRING <optional> }]
  }
]
*/

export default function SelectList({
  data = [],
  value = [],
  onChange: setValue,
  loading,
  emptyListMessage = "No items available",
  secondaryValue,
  secondaryOnChange = () => {},
  secondaryLabel
}) {
  return useMemo(
    () => (
      <div className={styles.selectList}>
        {secondaryLabel && (
          <Checkbox
            onChange={secondaryOnChange}
            checked={secondaryValue}
            className={styles.checkBox}
            large={true}
          >
            <span className={styles.checkBoxLabel}>{secondaryLabel}</span>
          </Checkbox>
        )}
        {data.map((item) =>
          item.children && item.children.length ? (
            <NestedSelectItem
              key={item.value}
              value={value}
              setValue={setValue}
              data={item}
            />
          ) : (
            <SelectItem
              key={item.value}
              value={value}
              setValue={setValue}
              data={item}
            />
          )
        )}
        {loading && <Spinner className={styles.loading} />}
        {!loading && !data.length && (
          <span className={styles.emptyList}>{emptyListMessage}</span>
        )}
      </div>
    ),
    [data, value, loading]
  );
}
